import { render } from "./BreakageInfoDialog.vue?vue&type=template&id=245c4602&scoped=true"
import script from "./BreakageInfoDialog.vue?vue&type=script&lang=js"
export * from "./BreakageInfoDialog.vue?vue&type=script&lang=js"

import "./BreakageInfoDialog.vue?vue&type=style&index=0&id=245c4602&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245c4602"]])

export default __exports__